var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipsis = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 4,
  viewBox: "0 0 18 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  fill: "#4F4F4F"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 2,
  r: 2,
  fill: "#4F4F4F"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 2,
  r: 2,
  fill: "#4F4F4F"
})));
export default SvgEllipsis;